<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="scarListWrap">
          <div class="datepicker-trigger search">
            <input
              type="text"
              id="datepicker-trigger"
              placeholder="Select dates"
              :value="formatDates(dateOne)"
            >
            <AirbnbStyleDatepicker
              :trigger-element-id="'datepicker-trigger'"
              :mode="'single'"
              :date-one="dateOne"
              :monthsToShow="1"
              :inline="true"
              :widthSet= calendarWidth
              :customized-dates="[
      { cssClass: 'normal', dates: ['2020-04-20', '2020-04-21'] },
      { cssClass: 'range', dates: ['2020-04-24', '2020-03-25'] }
    ]"
              :showShortcutsMenuTrigger="false"
              @date-one-selected="val => {
                this.initUploadSet()
              this.dateOne = val
              this.initUploadSet()
            }"
              @next-month="val => {
              this.dateOne = val
            }"
              @previous-month="val => {
              this.dateOne = val
            }"
            />
          </div>
          <div class="timeStampWrap">
            <div class="item" v-if = 'dateOne'>
              <div class="dateTime">
                <h2>선택하신 날짜는</h2>
                <h2 class="point">{{dateOne}} 입니다.</h2></div>
              <div class="imgUploadSet">
                <div class="uploadItem">
                  <div class="uploadImgWrap">
                    <div clas="viewImg">
                      <img src="@/assets/images/plusBtn.png">
                    </div>
                    <input type="file" v-if="isIOS" @change="onFileChange" multiple="" class="boneImg"/>
                    <input type="file" v-else @change="onFileChange" multiple="" class="boneImg"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="item" v-else>
              <h4 class="empty">등록날짜를 선택해주세요.</h4>
            </div>
          </div>
          <!--<div class="imagePreView">
            <div class="uploadImgWrap" v-for="(urlSet, u) in this.uploadData.url" :key="u">
              <img :src="urlSet" />
            </div>
          </div>-->
          <div class="imageSet space">
            <p class="prevBefore" v-if="!uploadData.isInArrived">선택한 사진리스트</p>
            <div class="viewWrap"  v-for="(urlSet, u) in this.uploadData.viewingUrl"
                 :key="u" :style="{ width: thumbWidth, height: thumbWidth}">
              <div class="preView">
                <img v-gallery:group1 :src = "urlSet">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btnWrap visible" v-if="uploadData.isInArrived">
        <button type="button" @click="callImage">사진 선택</button>
      </div>
      <div class="btnWrap visible" v-if="!uploadData.isInArrived">
        <button type="button" class="delete" @click="callImage">모두 비우기</button>
        <button type="button" class="beAct" @click="confirmPre()">등록</button>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet" @causeAction="confirmUpload()"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import format from 'date-fns/format'
import { getCookie } from '../../utils/cookieNew'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        closeType: 'close'
      },
      transDate: {
        headerName: '흉터관리',
        prevUrl: '/'
      },
      countNum: 0,
      dateFormat: 'D MMM',
      dateOne: '',
      calendarWidth: '',
      thumbWidth: '',
      uploadData: {
        url: [],
        viewingUrl: [],
        isInArrived: true
      },
      isIOS: false
    }
  },
  created () {
    this.setDeviceType()
    this.setCalendarVisual()
    const parts = document.location.href.split('/')
    console.log('5번쨰', parts[5])
    if (this.GET_UPLOAD_PRE_DATA.length <= 1) {
      this.SET_POPUP(true)
      this.popupSet.count = 'another'
      this.popupSet.content = '이미지 등록이 취소되었습니다.'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = `/scar/scarDetail/${parts[5]}`
      this.popupSet.nextLink = `/scar/scarDetail/${parts[5]}`
    }
  },
  mounted () {
    document.querySelector('.timeStampWrap').style.width = this.calendarWidth + 'px'
  },
  computed: {
    ...mapGetters([
      'GET_UPLOAD_PRE_DATA'
    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([
      'UPLOARD_SCAR_IMAGE'
    ]),
    setDeviceType () {
      if (getCookie('device') === 'I') {
        this.isIOS = true
      } else {
        this.isIOS = false
      }
    },
    confirmPre () {
      this.SET_POPUP(true)
      this.popupSet.content = '흉터이미지를 등록하시겠습니까?'
      this.popupSet.count = 'causeActionNormal'
    },
    async confirmUpload () {
      await this.uploadDataSet()
        .then(() => {
          this.uploadMessage()
        })
    },
    async uploadDataSet () {
      for (let i = 0; i < this.uploadData.url.length; i++) {
        this.uploadAction(i)
      }
    },
    uploadMessage () {
      this.SET_POPUP(true)
      this.popupSet.count = 'another'
      this.popupSet.content = '흉터이미지 등록이 완료되었습니다.'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = `/scar/scarDetail/${this.GET_UPLOAD_PRE_DATA.scarInfoCode}`
      this.popupSet.nextLink = `/scar/scarDetail/${this.GET_UPLOAD_PRE_DATA.scarInfoCode}`
    },
    async uploadAction (order) {
      console.log('진입', order)
      console.log('GET_UPLOAD_PRE_DATA', this.GET_UPLOAD_PRE_DATA)
      const imagefile = document.querySelector('.boneImg')
      try {
        const formData = new FormData()
        formData.append('scarInfoCode', this.GET_UPLOAD_PRE_DATA.scarInfoCode)
        formData.append('photo', imagefile.files[order])
        formData.append('afterMonth', this.GET_UPLOAD_PRE_DATA.afterMonth)
        formData.append('photoDate', this.dateOne)
        console.log('ㅇㅇ', formData)
        await this.UPLOARD_SCAR_IMAGE(formData)
      } catch (error) {
        console.log('error :', error);
        console.log('흉터관리 이미지 업로드 api에서 에러발생')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    callImage () {
      // api 호출, 리스트페이지에서 팝업호출할 수 있게 commit
      // 초기화들
      this.initUploadSet()
      document.querySelector('.boneImg').click()
    },
    async onFileChange (e) {
      /* if (e.target.files.length > 3) {
          this.SET_POPUP(true)
          this.popupSet.content = '이미지를 3개이상 선택할 수 없습니다.'
          return false
        } */
      await this.uploadImgInsert(e)
    },
    async uploadImgInsert (e) {
      console.log('이거 가져갈 수 있어?', e.target.files.length)
      const fileArray = []
      const viewIngArray = []
      for (let i = 0; i < e.target.files.length; i++) {
        fileArray.push(e.target.files[i])
        viewIngArray.push(URL.createObjectURL(e.target.files[i]))
      }
      this.uploadData.url = fileArray
      this.uploadData.viewingUrl = viewIngArray
      if (this.uploadData.viewingUrl.length >= 1) {
        this.uploadData.isInArrived = false
      }
    },
    initUploadSet () {
      this.uploadData.url = []
      this.uploadData.viewingUrl = []
      this.uploadData.isInArrived = true
    },
    setCalendarVisual () {
      this.calendarWidth = window.innerWidth - 48
      const alim = Number((this.calendarWidth / 3) - 4) + 'px'
      this.thumbWidth = alim
    },
    formatDates (dateOne) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat)
      }
      return formattedDates
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  },
  beforeDestroy () {
    this.SET_POPUP(false)
  }
}
</script>

<style lang="scss" scoped>
  .btnWrap {
    display:flex;
    button {
      &.delete {
        background:#4b4b4b;
      }
    }
  }
  .timeStampWrap {
    padding: 0;
    margin: 35px 0 25px 0;
    border: 0;
    text-align: center;
    .item {
      .dateTime {
        h2 {
          font-family: NotoSansCJKkr;
          font-size: 20px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.45;
          letter-spacing: normal;
          text-align: center;
          color:#fff;
          &.point {
            color:#ff6565;
          }
        }
      }
    }
  }
</style>
